exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".obtain-code[data-v-8c0ddfaa] {\n  border: 0 !important;\n  background: transparent !important;\n  border-left: 1px solid #DCDFE6 !important;\n  padding-left: 10px;\n  right: 0;\n}\n.obtain-code.is-disabled[data-v-8c0ddfaa] {\n  color: #C0C4CC !important;\n}\n.login-tips[data-v-8c0ddfaa] {\n  color: #333;\n  margin-top: 20px;\n}\n.login-tips .jump-login[data-v-8c0ddfaa] {\n  color: #275FE8;\n  font-size: 14px;\n  cursor: pointer;\n}\n[data-v-8c0ddfaa] .el-form-item .el-form-item__content .mask + .el-form-item__error {\n  display: none !important;\n}", ""]);

// exports
